import { render, staticRenderFns } from "./ContentProperty.vue?vue&type=template&id=3c09fb91&scoped=true&lang=html&"
import script from "./ContentProperty.vue?vue&type=script&lang=ts&"
export * from "./ContentProperty.vue?vue&type=script&lang=ts&"
import style0 from "./ContentProperty.vue?vue&type=style&index=0&id=3c09fb91&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c09fb91",
  null
  
)

export default component.exports